export function setExternalId(externalId) {
  if (window.fcWidget) {
    window.fcWidget.setExternalId(externalId);
  }
}

function doInitialize({ externalId, tags, callback, country, region }) {
  let token;
  let host;

  if (region === 'us') {
    token = '86a7059a-314b-42ce-a58c-abca6e336097';
    host = 'https://wchat.freshchat.com';
  } else if (region === 'eu' && country === 'GB') {
    token = 'f34afccd-cb8a-49b3-b8d9-c6d0055da762';
    host = 'https://wchat.eu.freshchat.com';
  } else if (['ap', 'oc'].includes(region)) {
    token = '17105859-3291-45f1-9050-1b62c2f23246';
    host = 'https://wchat.au.freshchat.com';
  }

  if (window.fcWidget) {
    window.fcWidget.init({
      token,
      host,
      tags,
      externalId,
    });
    callback(window.fcWidget);
  }
}

/**
 * @param {string} externalId ID to identify user, generated and stored by klarna
 * @param {(fcWidget) => {}} callback called when widget is loaded
 */
export function initFreshChat({
  externalId = null,
  tags = ['merchant-onboarding'],
  callback = () => null,
  country = 'US',
  region = 'us',
}) {
  const ELEMENT_ID = 'freshchat-js-sdk';
  let element = document.getElementById(ELEMENT_ID);
  let widget = 'https://wchat.freshchat.com/js/widget.js';
  if (['ap', 'oc'].includes(region)) {
    widget = 'https://wchat.au.freshchat.com/js/widget.js';
  }

  if (element) {
    doInitialize({ externalId, tags, callback, country, region });
  } else {
    element = document.createElement('script');
    element.id = ELEMENT_ID;
    element.async = true;
    element.src = widget;
    element.onload = () => doInitialize({ externalId, tags, callback, country, region });
    document.head.appendChild(element);
  }
}
